import styled from 'styled-components';

export const NavbarContainer = styled.div<{ bgColor: string }>`
  width: 100%;
  background-color: ${(props) => props.bgColor};
  display: none;
  flex-direction: column;
  grid-area: mobile-navbar;

  ${({ theme }) => theme.mediaQueries.md} {
    display: flex;
  }
`;
export const AboveNavbarItemsContentWrapper = styled.div<{ borderColor: string }>`
  width: 100%;
  display: flex;
  padding: 16px;
  background-color: transparent;
  border-bottom: 1px solid ${(props) => props.borderColor};
`;

export const NavbarItemsWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const NavbarItems = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  overflow-x: auto;
  direction: ltr;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const NavbarItem = styled.div<{ activeColor: string }>`
  a {
    width: fit-content;
    display: flex;
    flex-direction: row;
    align-items: center;
    transition: all 0.5s ease-in;
    gap: 10px;
    padding: 16px;
    position: relative;

    &::after {
      position: absolute;
      content: '';
      bottom: 0;
      left: 0;
      right: 0;
      height: 3px;
      background-color: transparent;
      transition: all 0.5s ease-in;
    }

    &:focus,
    &.active {
      > div {
        color: ${(props) => props.activeColor} !important;
      }

      &::after {
        background-color: ${(props) => props.activeColor};
      }

      > svg {
        path[stroke] {
          stroke: ${(props) => props.activeColor};
        }

        path[fill] {
          fill: ${(props) => props.activeColor};
        }
      }
    }
  }
`;
